import React from 'react';
import './MobileSearchDock.css';

interface MobileSearchDockProps {
  value: string;
  onChange: (value: string) => void;
  activeFilterCount: number;
  onOpenFilters: () => void;
  /** Extra class on the dock root: a page that owns a different gutter (Activity, 16px) hooks it here. */
  className?: string;
}

/**
 * Search field and filter button, pinned to the bottom of the viewport.
 *
 * Bottom rather than top so both land in thumb reach on a phone; the results
 * themselves own the rest of the screen.
 */
export const MobileSearchDock: React.FC<MobileSearchDockProps> = ({
  value,
  onChange,
  activeFilterCount,
  onOpenFilters,
  className,
}) => (
  <div className={className ? `mobile-search-dock ${className}` : 'mobile-search-dock'}>
    <input
      type="text"
      className="mobile-search-input"
      value={value}
      placeholder="Search cards"
      aria-label="Search cards"
      autoComplete="off"
      onChange={(e) => onChange(e.target.value)}
    />
    <button
      type="button"
      className="mobile-filter-button"
      onClick={onOpenFilters}
      aria-label={`Filters${activeFilterCount ? `, ${activeFilterCount} active` : ''}`}
    >
      Filters
      {activeFilterCount > 0 && (
        <span className="mobile-filter-badge">{activeFilterCount}</span>
      )}
    </button>
  </div>
);

export default MobileSearchDock;
